import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const trainingProfilesReducer = createAsyncReducer({
    name: 'trainingProfiles',
    initialState: {
        currentTrainingProfile: {},
        currentTrainingProfileLoading: false,
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        loadCurrentTrainingProfile: create.asyncThunk(
            async () => {
                return Fetch.get(Routes.ajax_training_profile_path());
            },
            {
                pending: (state, action) => {
                    state.currentTrainingProfileLoading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.currentTrainingProfileLoading = false;
                    state.currentTrainingProfile = action.payload;
                    if (action.payload.id) state.records = { ...state.records, [action.payload.id]: action.payload };
                },
                rejected: (state, action) => {
                    state.currentTrainingProfileLoading = false;
                    state.errorMessage = action.error;
                }
            }
        )
    })
});

export default trainingProfilesReducer;